// src/routes.js
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Dashboard from "views/Dashboard.js";
import Register from "views/auth-pages/Register.js";
import Login from "views/auth-pages/Login.js";
import PublicRoute from "components/common/PublicRoute";
import Protected from "components/common/ProtectedRoute";
import CicSettings from "views/account/CicSettings";
import CardImportPage from "views/import/CardImportPage";
import DatasetImportPage from "views/import/DatasetImportPage";
import UserTable from "views/user/UserTable";
import AddUser from "views/user/AddUser";
import ForgotPassword from "views/auth-pages/ForgotPassword";
import PasswordReset from "views/auth-pages/PasswordReset ";
import { UserContextProvider } from "context/UserContext";
import EditDatasetForm from "views/wineDataSet/EditDatasetForm";
import AddDatasetForm from "views/wineDataSet/AddDatasetForm";
import SingleWineDetail from "views/wineDataSet/SingleWineDetail";
import WineDataSetTable from "views/wineDataSet/WineDataSetTable";
import StylePage from "views/style/StylePage";
import PrintIndex from "views/menu-cards/PrintIndex";
import ProducersAdmin from "views/producers/ProducersAdmin";
import CategorySection from "views/category/CategorySection";
import SubCategorySection from "views/category/SubCategorySection";

import AddProductSections from "views/products/AddProductSection";
import SectionMenuItems from "views/products/SectionMenuItems";
import EditProductSection from "views/products/EditProductSection";
import SingleProductDetail from "views/products/SingleProductDetail";
import { getSectionIcon } from "utils/getSectionIcon";
import SectionProductsTable from "views/products/SectionProductsTable";
import UserProfile from "views/account/UserProfile";
import AIPage from "views/ai/AIPage";
import UnapprovedWineDataTable from "views/wineDataSet/UnapprovedWineDataTable";
import BeverageTable from "views/beverages/BeverageTable";
import BeverageForm from "views/beverages/BeverageForm";
import UnapprovedWineDataSingle from "views/wineDataSet/UnapprovedWineDataSingle";
import EditUnapprovedWineData from "views/wineDataSet/EditUnapprovedWineData";
import NotFound from "views/NotFound";
import Settings from "views/account/Settings";
import Bookings from "views/bookings/Bookings";
import BookingSettingsPage from "views/bookings/BookingSettingsPage";
import StatsPage from "views/bookings/StatsPage";
import TablesPage from "views/bookings/TablesPage";
import PendingBadge from "views/bookings/PendingBadge";
import Orders from "views/orders/Orders";
import MenuCards from "views/menu-cards/MenuCards";
import StructureEditor from "views/menu-cards/StructureEditor";

//     id: "f51e2b51-fa33-4535-8da8-a4f814bedfef",
//     name: "Food",
//     description: null,
//   },
//   {
//     id: "078193d7-b859-4174-a486-7223755b7274",
//     name: "Wine",
//     description: null,
//   },
//   {
//     id: "09706d2f-c15a-4f91-88a0-1bfac3baf3c2",
//     name: "Beverages",
//     description: null,
//   },
//   {
//     id: "fef1d71c-08b1-43f0-9634-514a675d3d84",
//     name: "Drinks",
//     description: null,
//   },
//   {
//     id: "0d20c73d-fcfd-4c3a-82a2-9c3b8d3ac8f0",
//     name: "Spirits",
//     description: null,
//   },
//   {
//     id: "b2d85e28-c411-43b5-a144-989c6c3565a9",
//     name: "Mixers",
//     description: null,
//   },
// ];

const buildStaticRoutes = (t) => [
  {
    path: "/dashboard",
    name: t("routes.dashboard"),
    rtlName: "لوحة القيادة",
    icon: "fas fa-chart-pie",
    showSidebar: true,

    component: (
      <Protected>
        <Dashboard />
      </Protected>
    ),
    layout: "/admin",
  },
  {
    path: "/settings",
    name: t("routes.settings"),
    rtlName: "لوحة القيادة",
    icon: "fas fa-chart-pie",
    showSidebar: false,

    component: (
      <Protected>
        <Settings />
      </Protected>
    ),
    layout: "/admin",
    allowedRoles: ["super_admin"],
  },
  {
    path: "/ai",
    name: t("routes.ai"),
    rtlName: "AI",
    icon: "fas fa-robot",
    component: (
      <Protected>
        <AIPage />
      </Protected>
    ),
    layout: "/admin",
    allowedRoles: ["super_admin"],
  },
  {
    path: "/producers",
    name: t("routes.producers"),
    rtlName: "Produttori",
    icon: "fas fa-wine-bottle",
    showSidebar: true,
    component: (
      <Protected>
        <ProducersAdmin />
      </Protected>
    ),
    layout: "/admin",
    allowedRoles: ["super_admin", "admin"],
  },
  {
    path: "/menu-cards",
    name: t("routes.wineCards"),
    rtlName: "Wine cards",
    icon: "fas fa-book-open",
    showSidebar: false, // si raggiunge da Drinks Cards / Menu Cards
    component: (
      <Protected>
        <MenuCards />
      </Protected>
    ),
    layout: "/admin",
    allowedRoles: ["user"],
    requiresModule: "wine",
  },
  {
    path: "/menu-cards/print",
    name: t("routes.print"),
    rtlName: "Stampa",
    showSidebar: false,
    component: (
      <Protected>
        <PrintIndex />
      </Protected>
    ),
    layout: "/admin",
    allowedRoles: ["user"],
    requiresModule: "wine",
  },
  {
    path: "/menu-cards/:id/structure",
    name: t("routes.cardStructure"),
    rtlName: "Card structure",
    icon: "fas fa-book-open",
    showSidebar: false,
    component: (
      <Protected>
        <StructureEditor />
      </Protected>
    ),
    layout: "/admin",
    allowedRoles: ["user"],
    requiresModule: "wine",
  },
  {
    path: "/login",
    name: t("routes.login"),
    mini: "L",
    rtlMini: "هعذا",
    showSidebar: false,

    component: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
    layout: "/auth",
  },
  {
    path: "/forgot-password",
    name: t("routes.forgotPassword"),
    rtlName: "هعذاتسجيل الدخول",
    mini: "FP",
    rtlMini: "هعذا",
    showSidebar: false,

    component: (
      <PublicRoute>
        <ForgotPassword />
      </PublicRoute>
    ),
    layout: "/auth",
  },
  {
    path: "/password/reset/:id/:token",
    name: t("routes.resetPassword"),
    rtlName: "هعذاتسجيل الدخول",
    mini: "PR",
    rtlMini: "هعذا",
    showSidebar: false,

    component: (
      <PublicRoute>
        <PasswordReset />
      </PublicRoute>
    ),
    layout: "/auth",
  },
  {
    path: "/account",
    name: t("routes.userProfile"),
    rtlName: "ملف تعريفي للمستخدم",
    mini: "UP",
    rtlMini: "شع",
    showSidebar: false,

    component: (
      <Protected>
        <UserProfile />
      </Protected>
    ),
    layout: "/admin",
  },
  {
    path: "/register",
    name: t("routes.register"),
    rtlName: "تسجيل",
    mini: "R",
    rtlMini: "صع",
    showSidebar: false,

    component: (
      <PublicRoute>
        <Register />
      </PublicRoute>
    ),
    layout: "/auth",
  },
  {
    collapse: true,
    name: t("routes.users"),
    rtlName: "صفحات",
    icon: "fas fa-users",
    state: "importUserCollapse",
    views: [
      {
        path: "/user-list",
        name: t("routes.usersList"),
        rtlName: "عالتسعير",
        mini: "UL",
        rtlMini: "ع",
        showSidebar: true,

        component: (
          <Protected>
            <UserTable />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin", "reseller"],
      },
      {
        path: "/add-user",
        name: t("routes.addUser"),
        rtlName: "عالتسعير",
        mini: "AU",
        rtlMini: "ع",
        showSidebar: true,

        component: (
          <Protected>
            <AddUser />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin", "reseller"],
      },
    ],
  },
  {
    collapse: true,
    name: t("routes.checkoutImport"),
    rtlName: "صفحات",
    icon: "fas fa-cash-register",
    state: "importProductCollapse",
    views: [
      {
        path: "/import-product",
        name: t("routes.cassaInCloud"),
        rtlName: "عالتسعير",
        mini: "CIC",
        rtlMini: "ع",
        showSidebar: true,

        component: (
          <Protected>
            <CicSettings />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user", "reseller"],
      },
      {
        path: "/import-wines",
        name: t("routes.cardsFromFile"),
        rtlName: "عالتسعير",
        mini: "CSV",
        rtlMini: "ع",
        requiresModule: "wine",
        component: (
          <Protected>
            <CardImportPage />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user"],
      },
    ],
  },

  // Prenotazioni e ordini: ognuno è una sezione con la sua pagina e il suo Style (visibile solo con il modulo attivo).
  {
    collapse: true,
    name: t("routes.bookings"),
    rtlName: "Bookings",
    icon: "fas fa-calendar-check",
    state: "bookingsCollapse",
    requiresModule: "bookings",
    views: [
      {
        path: "/bookings",
        name: t("routes.myBookings"),
        rtlName: "My Bookings",
        badge: <PendingBadge />, // contatore oro delle prenotazioni In attesa
        showSidebar: true,
        component: (
          <Protected>
            <Bookings />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user"],
        requiresModule: "bookings",
      },
      {
        path: "/bookings/statistics",
        name: t("routes.bookingsStatistics"),
        rtlName: "Statistics",
        showSidebar: true,
        component: (
          <Protected>
            <StatsPage />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user"],
        requiresModule: "bookings",
      },
      {
        path: "/bookings/tables",
        name: t("routes.bookingsTables"),
        rtlName: "Tables & rooms",
        showSidebar: true,
        component: (
          <Protected>
            <TablesPage />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user"],
        requiresModule: "bookings",
      },
      { linkOnly: true, path: "/style?area=booking", name: t("routes.bookingsStyle"), showSidebar: true, layout: "/admin", allowedRoles: ["user"], requiresModule: "bookings" },
      {
        path: "/bookings/settings",
        name: t("routes.bookingsSettings"),
        rtlName: "Settings",
        showSidebar: true,
        component: (
          <Protected>
            <BookingSettingsPage />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user"],
        requiresModule: "bookings",
      },
    ],
  },
  {
    collapse: true,
    name: t("routes.orders"),
    rtlName: "Orders",
    icon: "fas fa-shopping-bag",
    state: "ordersCollapse",
    requiresModule: "orders",
    views: [
      {
        path: "/orders",
        name: t("routes.myOrders"),
        rtlName: "My Orders",
        showSidebar: true,
        component: (
          <Protected>
            <Orders />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user"],
        requiresModule: "orders",
      },
      { linkOnly: true, path: "/style?area=order", name: t("routes.ordersStyle"), showSidebar: true, layout: "/admin", allowedRoles: ["user"], requiresModule: "orders" },
    ],
  },
  {
    collapse: true,
    name: t("routes.wineDataSet"),
    rtlName: "صفحات",
    icon: "fas fa-cube",
    state: "importDataSetCollapse",
    views: [
      {
        path: "/wine-dataset/import",
        name: t("routes.importCsv"),
        rtlName: "عالتسعير",
        mini: "CSV",
        rtlMini: "ع",
        component: (
          <Protected>
            <DatasetImportPage />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
      {
        path: "/wine-dataset/view",
        name: t("routes.dataSet"),
        rtlName: "عالتسعير",
        mini: "DS",
        rtlMini: "ع",
        component: (
          <Protected>
            <WineDataSetTable />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
      {
        path: "/wine-dataset/view/:id",

        name: t("routes.dataSetDetail"),
        rtlName: "عالتسعير",
        mini: "SD",
        rtlMini: "ع",
        showSidebar: false,

        component: (
          <Protected>
            <SingleWineDetail />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
      {
        path: "/wine-dataset/edit/:id",
        name: t("routes.editDataSet"),
        rtlName: "عالتسعير",
        mini: "ED",
        rtlMini: "ع",
        showSidebar: false,

        component: (
          <Protected>
            <EditDatasetForm />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
      {
        path: "/wine-dataset/add",
        name: t("routes.addDataSet"),
        rtlName: "عالتسعير",
        mini: "AD",
        rtlMini: "ع",
        showSidebar: false,

        component: (
          <Protected>
            <AddDatasetForm />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
      {
        path: "/wine-dataset/unapproved",
        name: t("routes.wineDataRequests"),
        rtlName: "عالتسعير",
        mini: "WDR",
        rtlMini: "ع",

        component: (
          <Protected>
            <UnapprovedWineDataTable />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },

      {
        path: "/wine-dataset/unapproved/view/:id",
        name: t("routes.wineDataRequest"),
        rtlName: "عالتسعير",
        mini: "WDP",
        rtlMini: "ع",

        component: (
          <Protected>
            <UnapprovedWineDataSingle />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
        showSidebar: false,
      },
      {
        path: "/wine-dataset/unapproved/edit/:id",
        name: t("routes.editWineDataRequest"),
        rtlName: "عالتسعير",
        mini: "WDP",
        rtlMini: "ع",

        component: (
          <Protected>
            <EditUnapprovedWineData />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
        showSidebar: false,
      },
    ],
  },
  {
    collapse: true,
    name: t("routes.beverageDataset"),
    rtlName: "صفحات",
    icon: "fas fa-cube",
    state: "beverageDataSetCollapse",
    views: [
      {
        path: "/beverages/view",
        name: t("routes.beverageRecords"),
        rtlName: "عالتسعير",
        mini: "SB",
        rtlMini: "ع",
        component: (
          <Protected>
            <BeverageTable />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
      {
        path: "/beverages/add",
        name: t("routes.newRecord"),
        rtlName: "عالتسعير",
        mini: "NS",
        rtlMini: "ع",
        showSidebar: false,
        component: (
          <Protected>
            <BeverageForm />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
      {
        path: "/beverages/edit/:id",
        name: t("routes.editRecord"),
        rtlName: "عالتسعير",
        mini: "MS",
        rtlMini: "ع",
        showSidebar: false,
        component: (
          <Protected>
            <BeverageForm />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["super_admin", "admin"],
      },
    ],
  },
  // {
  //   path: "not-found",
  //   name: "Not Found",
  //   rtlName: "صفحة غير ",
  //   showSidebar: false,

  //   component: (
  //     <Protected>
  //       <NotFound />
  //     </Protected>
  //   ),
  //   layout: "/admin",
  // },
];

// Il vino ha il suo modulo (dataset Wine Data); le altre sezioni usano piatti/bevande.
const isWine = (section) => (section?.name || "").toLowerCase() === "wine";

const useRoutes = () => {
  // useTranslation fa rirenderizzare il menu quando cambia la lingua
  const { t } = useTranslation("nav");
  const { sections, isLoading } = useContext(UserContextProvider);
  if (isLoading) {
    return [];
  }

  const dynamicRoutes = sections?.map((section) => ({
    collapse: true,
    showSidebar: false, // le voci di prodotto sono nei gruppi Drinks Cards / Menu Cards
    name: section.name,
    rtlName: "صفحات",
    icon: getSectionIcon(section?.name),
    state: `${section?.name?.toLowerCase()}ProductCollapse`,
    views: [
      {
        path: `/${section?.name?.toLowerCase()}/category`,
        name: t("routes.category"),
        rtlName: "عالتسعير",
        mini: "CAT",
        rtlMini: "ع",
        showSidebar: false, // le categorie si creano dentro le carte: voce tolta dal menu

        component: (
          <Protected>
            <CategorySection sectionData={section} />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user", "reseller"],
      },
      {
        path: `/${section?.name?.toLowerCase()}/sub-category`,
        name: t("routes.subCategory"),
        rtlName: "عالتسعير",
        mini: "SC",
        rtlMini: "ع",
        showSidebar: false, // idem

        component: (
          <Protected>
            <SubCategorySection sectionData={section} />
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user", "reseller"],
      },
      {
        path: `/${section?.name?.toLowerCase()}/products`,
        name: t("routes.product"),
        rtlName: "عالتسعير",
        mini: "P",
        rtlMini: "ع",
        showSidebar: true,
        component: (
          <Protected>
            {isWine(section) ? <SectionProductsTable sectionData={section} /> : <SectionMenuItems sectionData={section} />}
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user", "reseller"],
      },
      {
        path: `/${section?.name?.toLowerCase()}/product/add`,
        name: t("routes.addProduct"),
        rtlName: "عالتسعير",
        mini: "AP",
        rtlMini: "ع",
        showSidebar: false,

        component: (
          <Protected>
            {isWine(section) ? <AddProductSections sectionData={section} /> : <SectionMenuItems sectionData={section} mode="add" />}
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user", "reseller"],
      },
      {
        path: `/${section?.name?.toLowerCase()}/product/edit/:id`,
        name: t("routes.editProduct"),
        rtlName: "عالتسعير",
        mini: "EP",
        rtlMini: "ع",
        showSidebar: false,

        component: (
          <Protected>
            {isWine(section) ? <EditProductSection sectionData={section} /> : <SectionMenuItems sectionData={section} />}
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user", "reseller"],
      },
      {
        path: `/${section?.name?.toLowerCase()}/product/view/:id`,
        name: t("routes.sectionProduct", { name: section?.name }),
        rtlName: "عالتسعير",
        mini: "PV",
        rtlMini: "ع",
        showSidebar: false,

        component: (
          <Protected>
            {isWine(section) ? <SingleProductDetail sectionData={section} /> : <SectionMenuItems sectionData={section} />}
          </Protected>
        ),
        layout: "/admin",
        allowedRoles: ["user", "reseller"],
      },
    ],
  }));

  // Menu a sinistra del ristorante: due gruppi con le carte, la stampa e i prodotti di ogni sezione.
  const has = (name) => (sections || []).some((x) => x?.name?.toLowerCase() === name);
  const product = (name, label) =>
    has(name)
      ? [{ linkOnly: true, path: `/${name}/products`, name: label, showSidebar: true, layout: "/admin", allowedRoles: ["user", "reseller"] }]
      : [];
  const link = (path, name) => ({ linkOnly: true, path, name, showSidebar: true, layout: "/admin", allowedRoles: ["user"], requiresModule: "wine" });
  const cardGroups = [
    {
      collapse: true,
      name: t("routes.drinksCards"),
      rtlName: "Drinks Cards",
      state: "drinksCardsCollapse",
      views: [
        link("/menu-cards?type=drinks", t("routes.myDrinksCards")),
        link("/menu-cards/print?type=drinks", t("routes.drinksPrint")),
        link("/style?area=drinks", t("routes.drinksStyle")),
        ...product("wine", t("routes.wineProduct")),
        ...product("beverages", t("routes.beverageProduct")),
        ...product("drinks", t("routes.cocktailProduct")),
        ...product("spirits", t("routes.spiritsProduct")),
        ...product("mixers", t("routes.mixersProduct")),
      ],
    },
    {
      collapse: true,
      name: t("routes.foodCards"),
      rtlName: "Food Cards",
      state: "menuCardsCollapse",
      views: [
        link("/menu-cards?type=menu", t("routes.myFoodCards")),
        link("/menu-cards/print?type=menu", t("routes.foodPrint")),
        link("/style?area=food", t("routes.foodStyle")),
        ...product("food", t("routes.foodProduct")),
      ],
    },
  ];

  // Personalizzazione della carta online: una pagina, quattro aree (?area=drinks | food | booking | order).
  const styleRoute = {
    path: "/style",
    name: t("routes.style"),
    rtlName: "Style",
    showSidebar: false,
    component: (
      <Protected>
        <StylePage />
      </Protected>
    ),
    layout: "/admin",
    allowedRoles: ["user"],
  };

  const allRoutes = [...buildStaticRoutes(t), ...cardGroups, styleRoute, ...dynamicRoutes];
  return allRoutes;
};

export default useRoutes;
